var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "attention-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 30,
    viewBox: "0 0 36.36 152.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 22.117188 0 C 22.117188 1.8624877 22.106637 3.6821303 22.123047 5.5019531 A 16.501477 16.501477 0 0 0 22.251953 7.5625 C 22.407844 8.7111708 22.619884 9.8610944 22.808594 11.009766 C 23.095761 12.750822 23.381738 14.495735 23.673828 16.259766 L 26.246094 16.259766 A 3.0620282 3.0620282 0 0 0 26.322266 15.957031 C 26.589742 14.189719 26.86151 12.42325 27.119141 10.654297 C 27.320978 9.2578412 27.608814 7.8701284 27.677734 6.46875 C 27.77291 4.4881133 27.701172 2.5011846 27.701172 0.515625 C 27.701172 0.34332438 27.677734 0.16409583 27.677734 0 L 22.117188 0 z M 22.017578 19.046875 L 22.017578 25 L 27.982422 25 L 27.982422 19.046875 L 22.017578 19.046875 z ",
    transform: "matrix(6.094,0,0,6.094,-134.17,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attention-icon.a05dc21123aee71b678dcd668bdfb49d.svg";
export { ForwardRef as ReactComponent };